import { Injectable } from '@angular/core';
import { FieldDataType } from '../../store/models';
import { ViewControlType, CustomViewControlType } from 'src/app/modules/management/store/workflow';

import { TextFieldComponent } from './text-field/text-field.component';
import { DateFieldComponent } from './date-field/date-field.component';
import { MultiPicklistFieldComponent } from './multi-picklist-field/multi-picklist-field.component';
import { PicklistFieldComponent } from './picklist-field/picklist-field.component';
import { UrlFieldComponent } from './url-field/url-field.component';
import { NumberFieldComponent } from './number-field/number-field.component';
import { UidFieldComponent } from './uid-field/uid-field.component';
import { UserFieldComponent } from './user-field/user-field.component';
import { GeometryFieldComponent } from './geometry-field/geometry-field.component';
import { DocumentSummaryComponent } from './document-summary/document-summary.component';
import { WorkflowSelectComponent } from './workflow-select/workflow-select.component';
import { ImageFieldComponent } from './image-field/image-field.component';
import { BooleanFieldComponent } from './boolean-field/boolean-field.component';
import { ColorFieldComponent } from './color-field/color-field.component';
import { DistanceFieldComponent } from './distance-field/distance-field.component';
import { EmailFieldComponent } from './email-field/email-field.component';
import { PhoneFieldComponent } from './phone-field/phone-field.component';
import { AutoIncrementFieldComponent } from './auto-increment-field/auto-increment-field.component';
import { ReferenceFieldComponent } from './reference-field/reference-field.component';
import { ArrayFieldComponent } from './array-field/array-field.component';
import { CultureCodeFieldComponent } from './culture-code-field/culture-code-field.component';
import { CultureService } from '../../services/culture.service';
import { AddressFieldComponent } from './address-field/address-field.component';
import { DurationFieldComponent } from './duration-field/duration-field.component';
import { EnumerationFieldComponent } from './enumeration-field/enumeration-field.component';
import { BusinessUnitsFieldComponent } from './business-units-field/business-units-field.component';

@Injectable({ providedIn: 'root' })
export class DataTypeMapService {
  private dataTypeMap: any = {};
  private viewControlMap: any = {};
  private customViewControlMap: any = {};

  constructor() {
    //
    // field types to controls hash
    //
    this.dataTypeMap[FieldDataType.Text] = TextFieldComponent;
    this.dataTypeMap[FieldDataType.DateTime] = DateFieldComponent;
    this.dataTypeMap[FieldDataType.MultiPicklist] = MultiPicklistFieldComponent;
    this.dataTypeMap[FieldDataType.Picklist] = PicklistFieldComponent;
    this.dataTypeMap[FieldDataType.Url] = UrlFieldComponent;
    this.dataTypeMap[FieldDataType.Number] = NumberFieldComponent;
    this.dataTypeMap[FieldDataType.UId] = UidFieldComponent;
    this.dataTypeMap[FieldDataType.User] = UserFieldComponent;
    this.dataTypeMap[FieldDataType.Geometry] = GeometryFieldComponent;
    this.dataTypeMap[FieldDataType.Image] = ImageFieldComponent;
    this.dataTypeMap[FieldDataType.Boolean] = BooleanFieldComponent;
    this.dataTypeMap[FieldDataType.Color] = ColorFieldComponent;
    this.dataTypeMap[FieldDataType.Distance] = DistanceFieldComponent;
    this.dataTypeMap[FieldDataType.Email] = EmailFieldComponent;
    this.dataTypeMap[FieldDataType.Phone] = PhoneFieldComponent;
    this.dataTypeMap[FieldDataType.AutoIncrement] = AutoIncrementFieldComponent;
    this.dataTypeMap[FieldDataType.RelatedChild] = ReferenceFieldComponent;
    this.dataTypeMap[FieldDataType.RelatedParent] = ReferenceFieldComponent;
    this.dataTypeMap[FieldDataType.SingleReference] = ReferenceFieldComponent;
    this.dataTypeMap[FieldDataType.Array] = ArrayFieldComponent;
    this.dataTypeMap[FieldDataType.CultureCode] = CultureCodeFieldComponent;
    this.dataTypeMap[FieldDataType.Address] = AddressFieldComponent;
    this.dataTypeMap[FieldDataType.Duration] = DurationFieldComponent;
    this.dataTypeMap[FieldDataType.Enumeration] = EnumerationFieldComponent;
    this.dataTypeMap[FieldDataType.BusinessUnits] = BusinessUnitsFieldComponent;

    //
    // view control type to controls hash
    //
    this.viewControlMap[ViewControlType.DocumentSummary] = DocumentSummaryComponent;
    this.customViewControlMap[CustomViewControlType.WorkflowSelection] = WorkflowSelectComponent;
  }

  getComponentByDataType(dataType: number): any {
    return this.dataTypeMap[dataType];
  }

  getComponentByViewControlType(viewControlType: number): any {
    return this.viewControlMap[viewControlType];
  }

  getComponentByCustomViewControlType(customViewControlType: number): any {
    return this.customViewControlMap[customViewControlType];
  }
}
